import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import carousel1 from '../../../img/carousel-1.jpg';
import carousel2 from '../../../img/carousel-2.jpg';
import carousel3 from '../../../img/carousel-3.jpg';

const Carousel = () => {
    const settings = {
        dots: true,
        fade: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        waitForAnimate: false,
        arrows: true,
        swipeToSlide: false,
    };

    return (
        <Slider {...settings} className='carousel-slider'>
            <div>
                <img src={carousel1} alt="Slide 1" style={{ width: '100%', height: 700, position: 'relative', display: 'block', objectFit: 'cover' }} />
                <div className="carousel-caption">
                    <div className="carousel-caption-content p-3">
                        <h5 className="text-white text-uppercase fw-bold mb-4" style={{ letterSpacing: 3 }}>Hospital Unimed
                            Sudoeste Minas</h5>
                        <h1 className="display-1 text-capitalize text-white mb-4">UTI Neonatal</h1>
                    </div>
                </div>
            </div>
            <div>
                <img src={carousel2} alt="Slide 2" style={{ width: '100%', height: 700, position: 'relative', display: 'block', objectFit: 'cover' }} />
                <div className="carousel-caption">
                    <div className="carousel-caption-content p-3">
                        <h5 className="text-white text-uppercase fw-bold mb-4" style={{ letterSpacing: 3 }}>Hospital Unimed
                            Sudoeste Minas</h5>
                        <h1 className="display-1 text-capitalize text-white mb-4">UTI Neonatal</h1>
                    </div>
                </div>
            </div>
            <div>
                <img src={carousel3} alt="Slide 3" style={{ width: '100%', height: 700, position: 'relative', display: 'block', objectFit: 'cover' }} />
                <div className="carousel-caption">
                    <div className="carousel-caption-content p-3">
                        <h5 className="text-white text-uppercase fw-bold mb-4" style={{ letterSpacing: 3 }}>Hospital Unimed
                            Sudoeste Minas</h5>
                        <h1 className="display-1 text-capitalize text-white mb-4">UTI Neonatal</h1>
                    </div>
                </div>
            </div>
        </Slider>
    );
};

export default Carousel;
